import { render, staticRenderFns } from "./PreferencesPasswordForm.vue?vue&type=template&id=6023f363"
import script from "./PreferencesPasswordForm.vue?vue&type=script&lang=js"
export * from "./PreferencesPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./PreferencesPasswordForm.vue?vue&type=style&index=0&id=6023f363&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports